import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { companyService } from '../services/companyService';
import type { Company } from '../types/company.types';

export function useCompanySettings() {
  return useQuery({
    queryKey: ['company', 'settings'],
    queryFn: () => companyService.getCompanySettings(),
    staleTime: 2 * 60 * 1000,
    retry: 2,
    retryDelay: 1000,
  });
}

export function useUpdateCompanySettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (settings: Partial<Company>) => companyService.updateCompanySettings(settings),
    onSuccess: () => {
      // Invalidate all company-related queries to ensure data is refreshed everywhere
      queryClient.invalidateQueries({ queryKey: ['company', 'settings'] });
      queryClient.invalidateQueries({ queryKey: ['company', 'selected'] });
      queryClient.invalidateQueries({ queryKey: ['companies'] });
    },
  });
}
